<template>
    <section class="userSteps">
        <Header />
        <div class="d-flex justify-content-end padSpace" @click="store.clearMessage" v-if="store.error.msg">
            <button type="button" class="close_btn">
                <vue-feather size="26" type="x"></vue-feather>
            </button>
        </div>
        <div class="publicProfile row align-items-center">
            <div class="col-12 d-flex align-items-center justify-content-between mb-4">
                <router-link class="d-flex align-items-center backBtn medium" :to="{name : 'create_broker_account7',params:{'id':this.$route.params.id}}" :class="[{'disabled' : !isAlreadyDone()}]">
                    <vue-feather class="me-2" type="arrow-left" size="15"></vue-feather> {{$t('pref_account.text1')}}
                </router-link>
                <div class="counterStep text-end">
                    <p>{{$t('pref_account.text2')}}</p>
                </div>
            </div>
            <div class="col-12">
                <div class="mainTitle mb-5">
                    <h3 class="mb-3 clash">{{$t('pref_account.text3')}}<span class="bgTitle">{{$t('pref_account.text4')}}</span></h3>
                </div>
            </div>
            <div class="col-12 col-md-6">
                <h4 class="mb-4">{{$t('pref_account.text5')}}</h4>
                <Form class="row personalDetails" @submit="submit" v-if="Object.keys(store.brokerSettingsList).length && store.brokerSettingsList.TRADING_PLATFORMS && Object.keys(store.brokerSettingsList.TRADING_PLATFORMS).length">
                    <div class="form-group">
                        <p class="f-15 medium">{{$t('pref_account.text6')}}</p>
                        <ul class="d-flex align-items-center justify-content-between overflow-auto">
                            <li class="pe-3" v-for="value,key in store.brokerSettingsList.TRADING_PLATFORMS" :key="key">
                                <label class="customCheckBox f-18 medium dark radio text-nowrap">{{key}}
                                    <input type="radio" name="radio" v-model="form.platform" :value="key" />
                                    <span class="checkmark"></span>
                                </label>
                            </li>
                        </ul>
                    </div>
                    <div class="col-12" v-if="form.platform">
                        <div class="countrySelect form-group position-relative filter-dropdown" :class="form.currency ? 'selected' : ''">
                            <a @click="selectCurrency = !selectCurrency" href="javascript:void(0)" class="selectButton d-flex align-items-center justify-content-between">
                                {{(!form.currency) ? '&nbsp;' : form.currency}}
                                <vue-feather size="20" type="chevron-down"></vue-feather>
                            </a>
                            <label class="afterSelect">{{$t('pref_account.text7')}}</label>
                            <ul class="dropdown_menu_animated scrollable" :class="selectCurrency ? 'show' : ''">
                                <li v-for="value,key in store.brokerSettingsList.TRADING_PLATFORMS[form.platform].CURRENCY" :key="key">
                                    <a href="javascript:void(0)" @click="form.currency = value;selectCurrency = false">{{value}}</a>
                                </li>
                            </ul>
                        </div>
                    </div>
                    <div class="col-12" v-if="form.currency">
                        <div class="countrySelect form-group position-relative filter-dropdown" :class="form.leverage ? 'selected' : ''">
                            <a @click="selectLeverage = !selectLeverage" href="javascript:void(0)" class="selectButton d-flex align-items-center justify-content-between">
                                {{(!form.leverage) ? '&nbsp;' : form.leverage}}
                                <vue-feather size="20" type="chevron-down"></vue-feather>
                            </a>
                            <label class="afterSelect">{{$t('pref_account.text8')}}</label>
                            <ul class="dropdown_menu_animated scrollable" :class="selectLeverage ? 'show' : ''">
                                <li v-for="value,key in store.brokerSettingsList.TRADING_PLATFORMS[form.platform].LEVERAGE" :key="key">
                                    <a href="javascript:void(0)" @click="form.leverage = value;selectLeverage = false">{{value}}</a>
                                </li>
                            </ul>
                        </div>
                    </div>
                    <float-label class="form-group" v-if="form.leverage">
                    <div class="position-relative iconInput">
                        <!-- <input type="password" class="form-control" placeholder="Enter Password" /> -->
                        <Field
                          :type="inputtype"
                          class="form-control"
                          autofill="off"
                          name="password"
                          v-model="form.password"
                          rules="required|min:8"
                          :placeholder="$t('pref_account.text9')"
                          autocomplete="new-password"
                        />
                        <ErrorMessage class="text-danger" name="password" />
                        <vue-feather class="position-absolute eye pointer"  :type="iconType" size="23" @click="switchVisibility"></vue-feather>
                      </div>
                    </float-label>
                    <div class="col-6">
                        <button type="submit" class="grd_btn full_size" :class="((!form.currency || !form.platform || !form.leverage ))?'disabled' : ''">
                            {{$t('pref_account.text10')}}
                        </button>
                    </div>
                </Form>
            </div>
        </div>
    </section>
</template>
<script>
    import { useMainStore } from "@/store";
    import { Form, Field, ErrorMessage } from "vee-validate";
    import FloatLabel from 'vue-float-label/components/FloatLabel'
    export default {
        setup() {
            const store = useMainStore();
            return { store };
        },
        data() {
            return {
                selectCurrency: false,
                selectPlatform: false,
                selectLeverage: false,
                form: {
                    currency: "",
                    platform: false,
                    leverage: "",
                    password: "",
                },
                showpassword: false,
                iconType: "eye-off",
                inputtype: "password",
            };
        },
        components: {
            FloatLabel,
            Form,
            Field,
            ErrorMessage,
        },
        methods: {
            switchVisibility() {
              this.showpassword = !this.showpassword;
              if (this.showpassword) {
                this.inputtype = "text";
                this.iconType = "eye";
              } else {
                this.inputtype = "password";
                this.iconType = "eye-off";
              }
    },
            isAlreadyDone(){
                if(Object.keys(this.store.brokerStatusList).length && this.store.brokerStatusList.stepsStatus && this.store.brokerStatusList.stepsStatus.length){
                    this.store.brokerStatusList.stepsStatus.forEach(val => {
                        if(val.step == 'SumSub' && val.completed){
                            return false
                        }else{
                            return true
                        }
                    })
                }else{
                    return true
                }
            },
            submit() {
                let formData = {
                    currency: this.form.currency,
                    platform: this.form.platform,
                    leverage: this.form.leverage,
                    password: this.form.password,
                };
                this.store.addBrokerAccountPrefrences(formData, true, this.$route.params.id).then((res)=>{
                    if(res){
                        let form = {
                            'grant_type' : 'refresh_token',
                            'refresh_token' : this.store.user.refresh_token
                        };
                        this.store.refreshToken(form,false,'basic').then((response) =>{
                            if(response.access_token){
                                this.store.getUserAccountsList({},false)
                            }
                        })
                    }
                })
            },
        },
    };
</script>
